'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BLOCKS_PER_YEAR = exports.TOTAL_AMB_SUPPLY = exports.DEFAULT_BLOCK_RATE = exports.ATLAS3_RELATIVE_STRENGTH = exports.ATLAS2_RELATIVE_STRENGTH = exports.ATLAS1_RELATIVE_STRENGTH = exports.FIRST_PHASE_DURATION = exports.ROUND_DURATION = exports.DMP_PRECISION = exports.APPROVALS_REQUIRED = exports.ZERO_ADDRESS = exports.APOLLO_DEPOSIT = exports.ATLAS3_STAKE = exports.ATLAS2_STAKE = exports.ATLAS1_STAKE = exports.ROLE_REVERSE_CODES = exports.ROLE_CODES = exports.APOLLO = exports.HERMES = exports.ATLAS = exports.NONE = exports.MIN_BLOCK_TIME = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ROLE_REVERSE_CODES; /*
                         Copyright: Ambrosus Inc.
                         Email: tech@ambrosus.io
                         
                         This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.
                         
                         This Source Code Form is “Incompatible With Secondary Licenses”, as defined by the Mozilla Public License, v. 2.0.
                         */

var _web3_tools = require('./utils/web3_tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_BLOCK_TIME = exports.MIN_BLOCK_TIME = 5;

var NONE = exports.NONE = '0';
var ATLAS = exports.ATLAS = '1';
var HERMES = exports.HERMES = '2';
var APOLLO = exports.APOLLO = '3';
var ROLE_CODES = exports.ROLE_CODES = { NONE: NONE, ATLAS: ATLAS, HERMES: HERMES, APOLLO: APOLLO };
var ROLE_REVERSE_CODES = exports.ROLE_REVERSE_CODES = (_ROLE_REVERSE_CODES = {}, (0, _defineProperty3.default)(_ROLE_REVERSE_CODES, NONE, 'NONE'), (0, _defineProperty3.default)(_ROLE_REVERSE_CODES, ATLAS, 'ATLAS'), (0, _defineProperty3.default)(_ROLE_REVERSE_CODES, HERMES, 'HERMES'), (0, _defineProperty3.default)(_ROLE_REVERSE_CODES, APOLLO, 'APOLLO'), _ROLE_REVERSE_CODES);

var ATLAS1_STAKE = exports.ATLAS1_STAKE = _web3_tools.utils.toWei('10000');
var ATLAS2_STAKE = exports.ATLAS2_STAKE = _web3_tools.utils.toWei('30000');
var ATLAS3_STAKE = exports.ATLAS3_STAKE = _web3_tools.utils.toWei('75000');
var APOLLO_DEPOSIT = exports.APOLLO_DEPOSIT = _web3_tools.utils.toWei('250000');

var ZERO_ADDRESS = exports.ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

var APPROVALS_REQUIRED = exports.APPROVALS_REQUIRED = 4;

var DMP_PRECISION = exports.DMP_PRECISION = 10000;
var ROUND_DURATION = exports.ROUND_DURATION = 5 * 60;
var FIRST_PHASE_DURATION = exports.FIRST_PHASE_DURATION = 2 * 60 * 60;
var ATLAS1_RELATIVE_STRENGTH = exports.ATLAS1_RELATIVE_STRENGTH = 1;
var ATLAS2_RELATIVE_STRENGTH = exports.ATLAS2_RELATIVE_STRENGTH = 4;
var ATLAS3_RELATIVE_STRENGTH = exports.ATLAS3_RELATIVE_STRENGTH = 12;

var DEFAULT_BLOCK_RATE = exports.DEFAULT_BLOCK_RATE = 2;
var TOTAL_AMB_SUPPLY = exports.TOTAL_AMB_SUPPLY = '361477437535701402159030000';
var BLOCKS_PER_YEAR = exports.BLOCKS_PER_YEAR = 365 * 24 * 60 * 60 / 5;